export const textAllowed = (
  ev: any, callback: (val: string) => void) => {
  const re = /[0-9A-Za-zА-Яа-я\s]/;
  if (re.test(ev.target.value) || ev.target.value === '') {
      callback(ev.target.value.trimLeft())
      return;
  }
}export const textAllowed = (
  ev: any, callback: (val: string) => void) => {
  const re = /[0-9A-Za-zА-Яа-я\s]/;
  if (re.test(ev.target.value) || ev.target.value === '') {
      callback(ev.target.value.trimLeft())
      return;
  }
}